// extracted by mini-css-extract-plugin
export default {"notifications":"Notifications_notifications__eZ+4y","notifications__title":"Notifications_notifications__title__WbSJs","spin":"Notifications_spin__Ehy9K"};